import React from "react";
import "./src/styles/index.css";
import { Prism } from "prism-react-renderer";
require("prismjs/themes/prism-okaidia.css");
(typeof global !== "undefined" ? global : window).Prism = Prism;
require("prismjs/components/prism-csharp");
require("prismjs/components/prism-json");
require("prismjs/components/prism-bash");

const App = ({ element }: { element: React.ReactElement }) => {
  return <>{element}</>;
};

const Wrapper = ({ element }) => {
  return <App element={element} />;
};

export const wrapRootElement = Wrapper;

export const onClientEntry = () => {
  window.addEventListener("error", (event: ErrorEvent) => {
    const msg = event?.message || "";

    const targetSrc = (event.target as EventTarget & { src: string })?.src || "";

    const isStaticQueryError =
      msg.includes("StaticQuery") ||
      msg.includes("Loading chunk") ||
      targetSrc.includes("/page-data/") ||
      targetSrc.includes("/sq/d/");

    if (isStaticQueryError && !window.location.search) {
      console.warn("Detected failed Gatsby chunk or page-data load — reloading...");
      window.location.href = window.location.pathname + "?t=" + Date.now();
    }
  });
};
